import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { BookOpen, GraduationCap, ShoppingBag } from 'lucide-react';

export const RoleSelectionModal = ({ open, onClose, onSelectRole }) => {
  const roles = [
    {
      id: 'student',
      title: 'Learner',
      description: 'Enroll in courses, learn new skills, and track your progress',
      icon: BookOpen,
      color: '#163329',
      bgColor: '#E8F5E9',
    },
    {
      id: 'teacher',
      title: 'Teacher',
      description: 'Create courses, share your expertise, and inspire learners',
      icon: GraduationCap,
      color: '#D86B47',
      bgColor: '#FFF3E0',
      hidden: true,
    },
    {
      id: 'seller',
      title: 'User/Seller/Drop-Shipping',
      description: 'Learn skills and sell products in the Insight Warehouse',
      icon: ShoppingBag,
      color: '#6B5B95',
      bgColor: '#F3E5F5',
    },
  ];

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-lg" data-testid="role-selection-modal">
        <DialogHeader className="text-center">
          <DialogTitle 
            className="text-2xl font-bold"
            style={{ fontFamily: 'Spectral, serif', color: '#163329' }}
          >
            Welcome to Insight Evolution
          </DialogTitle>
          <DialogDescription className="text-base pt-2" style={{ color: '#5C635A' }}>
            Select how you'd like to get started
          </DialogDescription>
        </DialogHeader>
        
        <div className="grid gap-4 py-4">
          {roles.filter((role) => !role.hidden).map((role) => {
            const IconComponent = role.icon;
            return (
              <button
                key={role.id}
                onClick={() => onSelectRole(role.id)}
                className="flex items-center gap-4 p-4 rounded-xl border-2 transition-all duration-200 hover:scale-[1.02] hover:shadow-lg text-left group"
                style={{ 
                  borderColor: '#E3E1DB',
                  backgroundColor: '#FFFFFF',
                }}
                data-testid={`role-option-${role.id}`}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = role.color;
                  e.currentTarget.style.backgroundColor = role.bgColor;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = '#E3E1DB';
                  e.currentTarget.style.backgroundColor = '#FFFFFF';
                }}
              >
                <div 
                  className="flex-shrink-0 w-14 h-14 rounded-full flex items-center justify-center transition-colors"
                  style={{ backgroundColor: role.bgColor }}
                >
                  <IconComponent 
                    className="h-7 w-7 transition-transform group-hover:scale-110" 
                    style={{ color: role.color }} 
                  />
                </div>
                <div className="flex-1">
                  <h3 
                    className="font-semibold text-lg mb-1"
                    style={{ color: '#163329' }}
                  >
                    {role.title}
                  </h3>
                  <p 
                    className="text-sm"
                    style={{ color: '#5C635A' }}
                  >
                    {role.description}
                  </p>
                </div>
                <div 
                  className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                  style={{ backgroundColor: role.color }}
                >
                  <svg 
                    className="w-4 h-4 text-white" 
                    fill="none" 
                    viewBox="0 0 24 24" 
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </button>
            );
          })}
        </div>

        <p className="text-center text-xs" style={{ color: '#8B9187' }}>
          Already have an account? You can sign in after selecting your role.
        </p>
      </DialogContent>
    </Dialog>
  );
};
